import { cohortEndingSoonResDto } from '@web/common';
import { publicAPI } from '../PublicAPI';

export const getCohortsEndingSoon = async () => {
  return await publicAPI.get(
    `/api/cohort/onboarding/ending-soon`,
    cohortEndingSoonResDto,
  );
};
